import { FormControl, FormGroup } from '@angular/forms';
import { OperatingStateOption } from 'src/app/interfaces/operating-state-option';

export class VendorOperatingStatesForm extends FormGroup<{
  SubNationalDivisions: FormControl<OperatingStateOption[]>;
  savedSubNationalDivisions: FormControl<OperatingStateOption[]>;
}> {
  constructor() {
    super({
      SubNationalDivisions: new FormControl<OperatingStateOption[]>([], {
        nonNullable: true
      }),
      savedSubNationalDivisions: new FormControl<OperatingStateOption[]>([], {
        nonNullable: true
      })
    });
  }
}
